import { useEffect } from "react";

import { useCookies } from 'react-cookie';

import './App.css';
import RoutesApp from './routes';
import { AuthContext } from './store/AuthContext';

const App = () => {

  const [, , removeCookie] = useCookies(['hash']);

  useEffect(() => {

    console.log('app');
    removeCookie('hash');
    if (window.performance) {
      //console.log( "app This page is reloaded",AuthContext );
      if (performance.navigation.type === 1) {
        console.log( "app This page is reloaded",AuthContext );
      }
    }
    return () => {
      //unmount
      document.cookie = "hash=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
      removeCookie('hash');
    }
  //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
      <RoutesApp />
  );
}

export default App;
